import type { ComponentType, SVGProps } from 'react';

import { Text } from '../../cdl/Text/Text';
import { formatDateTime } from '../../common/helpers/formatDateTime.helper';
import { Characters } from '../../common/helpers/unicode.helper';

import { getSenderNameBySenderType } from './helpers';
import { TimelineItem } from './TimelineItem';
import type { OfferChatMessage } from './types';

interface SystemTimelineItemProps {
    message: OfferChatMessage;
    lineBefore: boolean;
    lineAfter: boolean;
    Icon?: ComponentType<SVGProps<SVGSVGElement>>;
}

export const SystemTimelineItem = ({ message, lineBefore, lineAfter, Icon }: SystemTimelineItemProps) => {
    const senderName = getSenderNameBySenderType(message);

    const absoluteTime = formatDateTime({
        date: message.dateCreated,
    });
    const hideSender = message.senderType === 'SYSTEM' && !Icon;

    return (
        <TimelineItem
            Icon={Icon}
            lineBefore={lineBefore}
            lineAfter={lineAfter}
            markerColor={message.senderType === 'SYSTEM' ? 'foreground.muted' : 'foreground.subtle'}
        >
            <Text
                variant="extraSmall"
                color="foreground.muted"
                style={{
                    display: '-webkit-box',
                    overflow: 'hidden',
                    userSelect: 'none',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                }}
            >
                {hideSender ? null : (
                    <>
                        <Text variant="extraSmall" fontWeight={500} color="foreground.muted">
                            {senderName}:
                        </Text>
                        {Characters.EN_SPACE}
                    </>
                )}
                <Text color="foreground.muted" variant="extraSmall">
                    {message.message}
                </Text>
                {Characters.EN_SPACE}
                {Characters.MIDDLE_DOT}
                {Characters.EN_SPACE}
                <Text color="foreground.muted" variant="extraSmall">
                    {absoluteTime}
                </Text>
            </Text>
        </TimelineItem>
    );
};
